import MobileMenuItemGraphql from '~/components/Atoms/MobileMenuItemGraphql.vue';
import ItemMarketingBannerGraphql from '~/components/Molecules/ItemMarketingBannerGraphql.vue';


export default {
  __name: 'MenuSidebarSecondLevelGraphql',
  props: {
  items: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: '',
  },
  marketingBanners: {
    type: Array,
    default: () => [],
  },
  isHighlight: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, MobileMenuItemGraphql, ItemMarketingBannerGraphql }
}

}